import { useState } from "react";
import { formatarDataCompleta } from "../../utils/functions";
import { inputClasses } from "../../atoms/formField";

/**
 * Anotações do pedido — disponíveis em qualquer etapa do wizard.
 * Substitui o antigo passo "Comentários": um painel recolhível no rodapé
 * do fluxo, gravando em productData.comments (mesmo formato de antes).
 */
const NotesPanel = ({ productData, setProductData }) => {

    const [open, setOpen] = useState(false);
    const [newComment, setNewComment] = useState("");

    const comments = productData?.comments ?? [];

    const submitComment = () => {
        const text = newComment.trim();
        if (!text) {
            return null;
        }
        setProductData(pd => ({ ...pd, comments: [...(pd?.comments ?? []), { date: new Date(), text }] }));
        setNewComment("");
    };

    const removeComment = (comment) => {
        setProductData(pd => ({ ...pd, comments: (pd?.comments ?? []).filter(c => c !== comment) }));
    };

    return (
        <section className="mt-2 rounded-xl border border-primary/20 bg-mgs-surface/50 text-left">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className="flex w-full items-center justify-between px-4 py-2.5 text-sm text-laranjinha/70 hover:text-laranjinha"
            >
                <span className="flex items-center gap-2">
                    <span aria-hidden="true">🗒</span>
                    Anotações do pedido
                    {comments.length ? (
                        <span className="rounded-full bg-primary px-2 text-xs font-semibold text-black">{comments.length}</span>
                    ) : null}
                </span>
                <span aria-hidden="true" className="text-xs">{open ? "▲ recolher" : "▼ abrir"}</span>
            </button>
            {open ? (
                <div className="border-t border-primary/20 px-4 py-3">
                    <p className="mb-2 text-xs text-laranjinha/50">
                        Anote o que quiser durante a criação — as anotações entram como comentários do pedido.
                    </p>
                    {
                        comments.length ? (
                            <ul className="mb-3 flex flex-col gap-1.5">
                                {comments.map((c, i) => (
                                    <li key={i} className="flex items-start justify-between gap-3 rounded-lg border border-primary/15 bg-mgs-bg/60 px-3 py-1.5">
                                        <span className="min-w-0">
                                            <span className="block text-sm text-laranjinha/90">{c?.text}</span>
                                            <span className="block text-[11px] text-laranjinha/40">{formatarDataCompleta(c?.date)}</span>
                                        </span>
                                        <button
                                            type="button"
                                            aria-label={`Remover anotação: ${c?.text}`}
                                            className="shrink-0 px-1 text-laranjinha/40 hover:text-red-400"
                                            onClick={() => removeComment(c)}
                                        >
                                            ×
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : null
                    }
                    <form
                        className="flex gap-2"
                        onSubmit={(e) => { e.preventDefault(); submitComment(); }}
                    >
                        <input
                            className={`${inputClasses} w-full`}
                            type="text"
                            maxLength={300}
                            placeholder="Escrever anotação…"
                            value={newComment}
                            onChange={e => setNewComment(e.target.value)}
                        />
                        <button
                            type="submit"
                            disabled={!newComment.trim()}
                            className="whitespace-nowrap rounded-lg bg-primary px-3 py-1 text-sm font-semibold text-black hover:bg-[#b47c06] disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            Anotar
                        </button>
                    </form>
                </div>
            ) : null}
        </section>
    );
};

export default NotesPanel;
